import { memo, useEffect, useRef, useState } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

function TableMultiLineText({
  value,
  showBooleanValues,
  showTooltip = true,
  uniqueId,
  lineClamp = 3,
}) {
  const ref = useRef(null);
  const [textTruncated, setTextTruncated] = useState(false);

  useEffect(() => {
    if (!ref.current) return;

    const resizeObserver = new ResizeObserver(m =>
      setTextTruncated(m[0].target.scrollHeight > m[0].target.clientHeight),
    );

    resizeObserver.observe(ref.current, { attributes: true });

    // eslint-disable-next-line consistent-return
    return () => resizeObserver.disconnect();
  }, []);

  const renderValue = () => {
    if (showBooleanValues && typeof value === 'boolean') {
      return value ? 'True' : 'False';
    }

    return value;
  };

  return (
    <OverlayTrigger
      placement="top"
      trigger={showTooltip && textTruncated ? ['hover', 'focus'] : []}
      delay={{ show: 200 }}
      popperConfig={{ modifiers: [{ name: 'offset', options: { offset: [0, 0] } }] }}
      overlay={<Tooltip className="tooltip-max-width">{renderValue()}</Tooltip>}
    >
      <div
        ref={ref}
        style={{
          overflow: 'hidden',
          display: '-webkit-box',
          verticalAlign: 'middle',
          WebkitLineClamp: lineClamp,
          lineClamp,
          WebkitBoxOrient: 'vertical',
        }}
        id={uniqueId}
      >
        {renderValue()}
      </div>
    </OverlayTrigger>
  );
}

export default memo(TableMultiLineText);
